<template id="forgotPass">
  <b-modal ref="fpModal" class="cpassword-container" :hide-footer="true" :hide-header="false"
           :title="unlockUser?'Unlock User':'Forgot Password'" size="lg"  no-close-on-backdrop>
    <div class="d-flex w-100 m-auto p-3 justify-content-center flex-column cpassword">
      <div class="loading-overlay" v-if="loading">
        <div class="spinner"></div>
        Loading...
      </div>
      <!--Alert Message-->
      <b-alert :show=dismissCountDown :variant="alertVariant" fade @dismiss-count-down="countDownChanged"> {{
          updateMsg
        }}
      </b-alert>
      <div v-if="otpGenerated || token!==null">
        Password must meet the following criteria:
        <div class="d-flex flex-row justify-content-between">
          <div class="flex-column">
            <p v-bind:class="{ valid: contains_eight_characters, invalid: !contains_eight_characters }"
               style="margin: 0">*Min 8 Characters</p>
            <p v-bind:class="{ valid: contains_number, invalid: !contains_number }" style="margin: 0">*Contains
              Number</p>
            <p v-bind:class="{ valid: contains_lowercase, invalid: !contains_lowercase }" style="margin: 0">*Contains
              Lowercase</p>
          </div>
          <div class="flex-column">
            <p v-bind:class="{ valid: contains_uppercase, invalid: !contains_uppercase }" style="margin: 0">*Contains
              Uppercase</p>
            <p v-bind:class="{ valid: contains_special_character, invalid: !contains_special_character }"
               style="margin: 0">*Contains Special Character</p>
            <p v-bind:class="{ valid: checkingConfirmPass, invalid: !checkingConfirmPass }">*New and confirm password
              {{ checkingConfirmPass ? 'match' : "do not match" }}.</p>
          </div>
        </div>

      </div>
      <form ref="fpForm" action="#" method="post" id="fpForm">
        <div class="form-group" v-if="token===null">
          <label class="float-left">Username </label>
          <input type="text" v-model="userName" class="form-control" placeholder="user name" required>
        </div>
        <div v-if="otpGenerated || token!==null">
          <div class="form-group" v-if="token===null">
            <label class="float-left">Enter OTP from your email</label>
            <input type="password" class="form-control"
                   id="" aria-describedby="emailHelp"
                   v-model="otp"
                   @input="checkPassword"
                   required
                   placeholder="One Time Password" :disabled='userName==null'>
          </div>
          <div class="form-group">
            <label class="float-left">New Password</label>
            <input type="password" @input="checkPassword" class="form-control"
                   id="" aria-describedby="emailHelp"
                   v-model="newPassword"
                   ref="newPassword"
                   required
                   placeholder="*New password" :disabled='userName==null'>
          </div>
          <div class="form-group">
            <label class="float-left">Confirm New Password</label>
            <input type="password" @input="confirmPassword" class="form-control"
                   id="" aria-describedby="emailHelp"
                   v-model="confirmPass"
                   ref="confirmPass"
                   required
                   placeholder="*Confirm new password" :disabled='userName==null'>
          </div>
        </div>
        <button type="reset" class="btn btn-secondary mr-3">Clear</button>
        <button type="button" v-on:click="validateUser()" class="btn btn-primary ml-3"
                :disabled="otpGenerated?isDisabled:false">{{ btnName }}
        </button>
      </form>
    </div>
  </b-modal>
</template>
<script>
import axios from 'axios'

export default {
  name: 'forgotPass',
  props: {
    unlockUser: Boolean
  },
  data() {
    function initData() {
      return {
        userName: null,
        userData: [],
        otp: "",
        loading: false,
        otpGenerated: false,
        btnName: "Submit",
        newPassword: null,
        confirmPass: null,
        resetPassFailed: false,
        checkingConfirmPass: false,
        /* password validation */
        password_length: 0,
        contains_eight_characters: false,
        contains_number: false,
        contains_uppercase: false,
        contains_lowercase: false,
        contains_special_character: false,
        valid_password: false,
        isDisabled: true,
        updateMsg: null,
        msgColor: null,
        alertVariant: 'danger',
        dismissSecs: 5,
        dismissCountDown: 0,
        token:null
      }
    }

    return initData()
  },
  mounted() {
  this.token =this.$route.query.token || null
    if(this.token){
      this.show()
      const obj={
        password:this.token
      }
      axios.post("/auth/decrypt-password",obj).then((resp)=>{
        console.log(resp);
        this.userName=resp.data
      })
    }
    console.log("token",this.token)
  },
  methods: {
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    show() {
      this.$refs.fpModal.show();
    },
    showLoading: function () {
      this.loading = true
    },
    hideLoading: function () {
      this.loading = false
    },
    validateUser: function () {
      if (this.otpGenerated || this.token!==null) {
        //call reset password api
        if(this.unlockUser || this.token!==null){
          this.unlockUserFunc();
        }else {
          this.resetPassword()
        }
      } else {
        this.showLoading()
        axios.post('/auth/validateUser', {
          "userName": this.userName,
          "unlockUser": this.unlockUser.toString()
        }).then((response) => {
          console.log("User validated", response.status)
          if (response.status === 200) {
            // alert("OTP generated and sent to your registered email.")
            this.updateMsg = "OTP generated and sent to your registered email."
            this.alertVariant = "success"
            this.showAlert()
          }
          if (this.unlockUser) {
            this.btnName = "Unlock & Reset Password"
            this.isDisabled = true
          } else {
            this.btnName = "Reset Password"
            this.isDisabled = true
          }

          this.otpGenerated = true

        }, error => {
          console.log("Error ", error.response)
          this.showAlert()
          this.alertVariant = "danger"
          this.errorTitle = error.response && error.response.data ? error.response.data.error : 'Something went wrong';
          this.updateMsg = this.errorTitle
          this.msgColor = 'red'
          this.$store.commit('authError')
          // alert(this.errorTitle)
        }).finally(() => this.hideLoading())
      }

    },
    checkPassword() {
      if (this.newPassword) {
        this.password_length = this.newPassword.length;
        const format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>?]/;

        this.contains_eight_characters = this.password_length >= 8;
        this.contains_number = /\d/.test(this.newPassword);
        this.contains_uppercase = /[A-Z]/.test(this.newPassword);
        this.contains_lowercase = /[a-z]/.test(this.newPassword);
        this.contains_special_character = format.test(this.newPassword);

        this.valid_password = this.contains_eight_characters === true && this.contains_special_character === true &&
            this.contains_uppercase === true && this.contains_number === true && this.contains_lowercase === true;
        this.confirmPassword()
      }

    },
    confirmPassword: function () {
      if (this.newPassword === this.confirmPass) {
        this.checkingConfirmPass = true
        if (this.valid_password === true && this.newPassword === this.confirmPass && this.otp && this.userName)
          this.isDisabled = false
      } else {
        this.checkingConfirmPass = false
        this.isDisabled = true
      }
      console.warn("confirm password: ", this.confirmPass, this.checkingConfirmPass, this.newPassword)
    },
    unlockUserFunc: function () {
      const val = this.token===null?this.otp:this.token
      this.$store.state.authRequired = false
      const formData = {
        userName: this.userName,
        newPassword:this.newPassword,
        otp: val
      };
      this.showLoading()
      axios.post(`/auth/unlock-user-with-otp`, formData).then((response) => {
        console.log("this.data: ", response.data)
        this.msgColor = 'green'
        console.log("User account unlocked successfully. Please close or press esc to login")
        this.alertVariant = "success"
        this.updateMsg = "User account unlocked successfully. You will be redirected to the login page shortly."
        this.showAlert()
        this.isDisabled = true
        setTimeout(async () => {
          console.log("Timeout data reset");
          Object.assign(this.$data, this.$options.data.apply(this));

          // Hide modal first
          if (this.$refs.fpModal) {
            this.$refs.fpModal.hide();
          }

          // Wait a moment for UI to settle
          await this.$nextTick();

          console.log("Navigating to /login");
          if(this.token===null){
            window.location.reload();
          }else {
            await this.$router.push("/login");
          }
        }, 5000); // optional shorter delay

      }, error => {
        this.errorTitle = error.response && error.response.data ? error.response.data.error : 'Something went wrong';
        this.showAlert()
        this.alertVariant = "danger"
        this.updateMsg = this.errorTitle
        this.msgColor = 'red'
        this.$store.commit('authError')
        this.resetPassFailed = !this.$store.state.serverIsDown
        // alert(this.errorTitle)
      }).finally(() => this.hideLoading())
    },
    resetPassword: function () {
      this.resetPassFailed = false
      this.$store.state.authRequired = false
      const formData = {
        userName: this.userName,
        newPassword: this.newPassword,
        otp: this.otp
      };
      this.showLoading()
      axios.post(`/auth/reset-password-with-otp`, formData).then((response) => {
        console.log("this.data: ", response.data)
        this.msgColor = 'green'
        console.log("Password updated successfully. Please close or press esc to login")
        this.alertVariant = "success"
        this.updateMsg = "Password updated successfully. You will be redirected to the login page shortly."
        this.showAlert()
        this.isDisabled = true

        setTimeout(() => {
              console.log("Timeout data reset")
              Object.assign(this.$data, this.$options.data.apply(this))
              this.$refs.fpModal.hide();

            }

            , 10000)

      }, error => {
        this.errorTitle = error.response && error.response.data ? error.response.data.error : 'Something went wrong';
        this.showAlert()
        this.alertVariant = "danger"
        this.updateMsg = this.errorTitle
        this.msgColor = 'red'
        this.$store.commit('authError')
        this.resetPassFailed = !this.$store.state.serverIsDown
        // alert(this.errorTitle)
      }).finally(() => this.hideLoading())
    }
  }
}
</script>
<style scoped>
.cpassword-container {
  display: flex;
  width: 100vh;
  height: 75vh;
  justify-content: center;
  align-content: center;
  align-items: center;
  align-self: center;
  padding-top: 50px;
}

.cpassword {
  box-shadow: 1px 2px 2px 3px #a7aeaa;
}


.loading-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7); /* 70% opacity background */
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 24px;
}

.spinner {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-left-color: #fff;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Add a green text color and a checkmark when the requirements are right */
.valid {
  color: green;
}

/*
.valid:before {
  position: relative;
  left: -35px;
  content: "&#10004;";
}
*/

/* Add a red text color and an "x" icon when the requirements are wrong */
.invalid {
  color: red;
}

/*
.invalid:before {
  position: relative;
  left: -35px;
  content: "&#10006;";
}
*/

</style>